import { useMemo } from 'react';
import { CalendarUtils } from '@/components/Calendar';
import { useCalendarConfig } from '@/hooks/useCalendarConfig.ts';

const useCalendarUtils = (): CalendarUtils => {
  const calendarConfig = useCalendarConfig();

  return useMemo(() => {
    return new CalendarUtils(calendarConfig);
  }, [calendarConfig]);
};

export default useCalendarUtils;
